'use strict';

exports.__esModule = true;
exports.widgetActions = exports.UPDATE_WIDGET_DETAILS = exports.LOAD_ALL_PRACTICES_REVIEWS = exports.LOAD_ALL_PRACTICES_REVIEWS_COUNT = exports.LOAD_SINGLE_PROFILE_REVIEWS = undefined;

var _doctifyUtils = require('doctify-utils');

if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Action', {
  value: require('react').PropTypes.shape({
    type: require('react').PropTypes.string.isRequired,
    payload: require('react').PropTypes.object.isRequired,
    response: require('react').PropTypes.object.isRequired,
    actionData: require('react').PropTypes.object.isRequired
  })
}); // This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var LOAD_SINGLE_PROFILE_REVIEWS = exports.LOAD_SINGLE_PROFILE_REVIEWS = 'BADGE_ACTIONS:LOAD_MAIN_PROFILE_REVIEWS';
var LOAD_ALL_PRACTICES_REVIEWS_COUNT = exports.LOAD_ALL_PRACTICES_REVIEWS_COUNT = 'BADGE_ACTIONS:LOAD_ALL_PRACTICES_REVIEWS_COUNT';
var LOAD_ALL_PRACTICES_REVIEWS = exports.LOAD_ALL_PRACTICES_REVIEWS = 'BADGE_ACTIONS:LOAD_ALL_PRACTICES_REVIEWS';
var UPDATE_WIDGET_DETAILS = exports.UPDATE_WIDGET_DETAILS = 'BADGE_ACTIONS:UPDATE_WIDGET_DETAILS';

var widgetActions = exports.widgetActions = {
  loadSingleProfileReviews: function loadSingleProfileReviews(profileId, profileType, xhrConfig) {
    return (0, _doctifyUtils.createAction)({
      xhrConfig: xhrConfig,
      url: profileType + '/' + profileId + '/aggregate_review',
      method: 'GET',
      actionType: LOAD_SINGLE_PROFILE_REVIEWS
    });
  },
  loadAllPracticesReviewsCount: function loadAllPracticesReviewsCount(practicesIds, xhrConfig) {
    return (0, _doctifyUtils.createAction)({
      xhrConfig: xhrConfig,
      url: '/practices/reviews/count',
      parameters: {
        ids: practicesIds.join(',')
      },
      method: 'GET',
      actionType: LOAD_ALL_PRACTICES_REVIEWS_COUNT
    });
  },
  loadAllPracticesReviews: function loadAllPracticesReviews(practicesIds, xhrConfig) {
    return (0, _doctifyUtils.createAction)({
      xhrConfig: xhrConfig,
      url: '/practices/reviews',
      parameters: {
        ids: practicesIds.join(','),
        status_filter: 'approved',
        verified_filter: true
      },
      method: 'GET',
      actionType: LOAD_ALL_PRACTICES_REVIEWS
    });
  },
  updateWidgetDetails: function updateWidgetDetails(isGroup, baseUrl, profileId, profileType, link) {
    return {
      type: UPDATE_WIDGET_DETAILS,
      payload: {
        isGroup: isGroup,
        baseUrl: baseUrl,
        profileId: profileId,
        profileType: profileType,
        link: link
      }
    };
  }
};